module.exports = __webpack_public_path__ + "img/transaction-active..635fa9df.svg";